import type { RouteLocationNormalized, RouteLocationRaw } from 'vue-router';

interface ModuleAwareTenant {
  status: string;
  sells: (module: string) => boolean;
}

export const moduleGate = (
  to: Pick<RouteLocationNormalized, 'meta'>,
  tenant: ModuleAwareTenant,
): RouteLocationRaw | undefined => {
  const module = to.meta.module;
  if (typeof module !== 'string') return undefined;
  if (tenant.status !== 'ready') return undefined;
  if (tenant.sells(module)) return undefined;
  return { path: '/', replace: true };
};
